let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3roEx")).then(() => parcelRequire('eDFE1'));